export default {
  "content": "<path d=\"M43.938 87.876c24.267 0 43.938-19.672 43.938-43.938C87.876 19.672 68.205 0 43.938 0 19.672 0 0 19.672 0 43.938c0 24.266 19.672 43.938 43.938 43.938z\" fill=\"#EBEBF0\"/><path d=\"M60.296 74.079a1.877 1.877 0 01-1.535-.81L40.068 46.152a1.868 1.868 0 01.113-2.25l16.074-18.9a1.872 1.872 0 012.853 2.421L43.96 45.252l17.878 25.933a1.872 1.872 0 01-1.543 2.934v-.04zM43.79 82.057a2.911 2.911 0 100-5.823 2.911 2.911 0 000 5.823zM44.093 11.637a2.912 2.912 0 100-5.823 2.912 2.912 0 000 5.823zM79.144 46.998a2.912 2.912 0 100-5.823 2.912 2.912 0 000 5.823zM8.735 46.697a2.911 2.911 0 100-5.823 2.911 2.911 0 000 5.822z\" fill=\"#8A8F9E\"/>",
  "attrs": {
    "width": "88",
    "height": "88",
    "viewBox": "0 0 88 88",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};